import { IDienstleistungInfo } from '../mgs.types';
import { IOption } from '@mng/mng-inputs';

export const BEARBEITUNGS_STATUS_ANGEFORDERT_ID = 1;

export const BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID = 2;

export const BEARBEITUNGS_STATUS_ABGESCHLOSSEN_ID = 3;

// Repraesentiert einen Bearbeitungsabschluss der automatisch vom System durchgefuehrt
// wurde -> wird aktuell nicht verwendet ist aber noch in wenigen alten
// Dienstleistungen gesetzt
export const BEARBEITUNGS_STATUS_ABGESCHLOSSEN_SYSTEM_ID = 4;

export const BEARBEITUNGS_STATUS_GEBUCHT_ID = 5;

export const istAngefordert = (dienstleistung: IDienstleistungInfo) =>
  dienstleistung.status.id === BEARBEITUNGS_STATUS_ANGEFORDERT_ID;

export const istGebucht = (dienstleistung: IDienstleistungInfo) =>
  dienstleistung.status.id === BEARBEITUNGS_STATUS_GEBUCHT_ID;
export const istInBearbeitung = (dienstleistung: IDienstleistungInfo) =>
  dienstleistung.status.id === BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID;

export const istAbgeschlossen = (dienstleistung: IDienstleistungInfo) =>
  dienstleistung.status.id === BEARBEITUNGS_STATUS_ABGESCHLOSSEN_ID;

export const istVorBearbeitungStatus = (dienstleistung: IDienstleistungInfo) =>
  istAngefordert(dienstleistung) || istGebucht(dienstleistung);

export const bearbeitungsStatusLabel = {
  [BEARBEITUNGS_STATUS_ANGEFORDERT_ID]: 'Angefordert',
  [BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID]: 'In Bearbeitung',
  [BEARBEITUNGS_STATUS_ABGESCHLOSSEN_ID]: 'Abgeschlossen',
  [BEARBEITUNGS_STATUS_ABGESCHLOSSEN_SYSTEM_ID]: 'Abgeschlossen (System)',
  [BEARBEITUNGS_STATUS_GEBUCHT_ID]: 'Gebucht'
};

export const bearbeitungStatusUserOptions: IOption[] = [
  {
    value: BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID,
    name: bearbeitungsStatusLabel[BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID]
  },
  { value: BEARBEITUNGS_STATUS_GEBUCHT_ID, name: bearbeitungsStatusLabel[BEARBEITUNGS_STATUS_GEBUCHT_ID] },
  { value: BEARBEITUNGS_STATUS_ABGESCHLOSSEN_ID, name: bearbeitungsStatusLabel[BEARBEITUNGS_STATUS_ABGESCHLOSSEN_ID] }
];

export const bearbeitungStatusSpowiOptions: IOption[] = [
  { value: BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID, name: bearbeitungsStatusLabel[BEARBEITUNGS_STATUS_IN_BEARBEITUNG_ID] }
];

export const bearbeitungStatusOptions: IOption[] = [
  { value: BEARBEITUNGS_STATUS_ANGEFORDERT_ID, name: bearbeitungsStatusLabel[BEARBEITUNGS_STATUS_ANGEFORDERT_ID] },
  ...bearbeitungStatusUserOptions
];

export const bearbeitungStatusWithEmptyOptions: IOption[] = [
  { value: undefined, name: '-' },
  ...bearbeitungStatusOptions
];
